<template>
  <nav class="kpt-portal-navbar" :class="{ 'kpt-portal-navbar-collapsed': menuCollapsed }">
    <ul>
      <li>
        <router-link to="/home">
          <span class="nav-icon">
            <font-awesome-icon :icon="['far', 'home-alt']" class="fa-lg"></font-awesome-icon>
          </span>
          <h6>Home</h6>
        </router-link>
      </li>
      <!-- <li v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed')">
        <router-link to="/remotes">
          <span class="nav-icon">
            <font-awesome-icon :icon="['far', 'satellite-dish']" size="lg" class="fa-lg"></font-awesome-icon>
          </span>
          <h6>Remotes</h6>
        </router-link>
      </li>
      <li v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed')">
        <router-link to="/devices">
          <span class="nav-icon">
            <font-awesome-icon :icon="['far', 'microchip']" class="fa-lg" />
          </span>
          <h6>Devices</h6>
        </router-link>
      </li> -->
      <li v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed')">
        <router-link to="/terminals">
          <span class="nav-icon">
            <font-awesome-icon :icon="['far', 'satellite-dish']" size="lg" class="fa-lg"></font-awesome-icon>
          </span>
          <h6>Terminals</h6>
        </router-link>
      </li>
      <!-- <li v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin')">
        <router-link to="/subscriptions">
          <span class="nav-icon" style="padding-left: 0px; padding-right: 37px;">
            <font-awesome-layers class="fa-lg">
              <font-awesome-icon :icon="['far', 'sync-alt']" />
              <font-awesome-icon :icon="['far', 'dollar-sign']" transform="shrink-9" :style="{ color: 'white' }" />
            </font-awesome-layers>
          </span>
          <h6>Subscriptions</h6>
        </router-link>
      </li> -->
      <li v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin')">
        <router-link to="/subscriptions">
          <span class="nav-icon" style="padding-left: 0px; padding-right: 37px;">
            <font-awesome-layers class="fa-lg">
              <font-awesome-icon :icon="['far', 'sync-alt']" />
              <font-awesome-icon :icon="['far', 'dollar-sign']" transform="shrink-9" :style="{ color: 'white' }" />
            </font-awesome-layers>
          </span>
          <h6>Subscriptions</h6>
        </router-link>
      </li>
      <!-- <li v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed')">
        <router-link to="/groups">
          <span class="nav-icon">
            <font-awesome-icon :icon="['far', 'object-group']" class="fa-lg" />
          </span>
          <h6>Groups</h6>
        </router-link>
      </li> -->
      <!-- <li>
        <router-link to="/reports">
          <b-icon icon="chart-bar"></b-icon>
          <h6>Reports</h6>
        </router-link>
      </li> -->
      <li v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support')">
        <router-link to="/api">
          <span class="nav-icon">
            <font-awesome-icon :icon="['far', 'brackets-curly']" class="fa-lg" />
          </span>
          <h6 class="truncate">Portal API</h6>
        </router-link>
      </li>
      <li>
        <router-link to="/documentation">
          <span class="nav-icon">
            <font-awesome-icon :icon="['far', 'file-alt']" class="fa-lg" />
          </span>
          <h6>Documentation</h6>
        </router-link>
      </li>
      <li>
        <router-link to="/software">
          <span class="nav-icon">
            <font-awesome-icon :icon="['far', 'album']" class="fa-lg" />
          </span>
          <h6>Software</h6>
        </router-link>
      </li>
      <li>
        <router-link to="/tools/optionsFileValidator">
          <span class="nav-icon">
            <font-awesome-icon :icon="['far', 'tools']" class="fa-lg" />
          </span>
          <h6>Tools</h6>
        </router-link>
      </li>
      <li v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin')">
        <router-link to="/admin">
          <span class="nav-icon">
            <font-awesome-icon :icon="['far', 'user-cog']" class="fa-lg" />
          </span>
          <h6>Admin</h6>
        </router-link>
      </li>
    </ul>
    <div class="spacer"></div>
    <ul>
      <li @click="toggleMenuCollapse">
        <a class="collapse-bar">
          <b-icon class="has-text-grey has-cursor-pointer" :icon="menuCollapsed ? 'chevron-double-right' : 'chevron-double-left'"></b-icon>
        </a>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  methods: {
    toggleMenuCollapse() {
      this.$store.commit('toggleMenuCollapse');
      this.$store.dispatch('updateSetting', { key: 'menuCollapsed', value: this.$store.state.user.settings.menuCollapsed });
    }
  },
  computed: {
    menuCollapsed() {
      return this.$store.state.user.settings.menuCollapsed;
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-portal-navbar {
  width: 190px;
  transition: width 0.1s ease;
  display: flex;
  flex-direction: column;

  .spacer {
    flex: 1 0 auto;
  }

  ul {
    li {
      a {
        padding: 22px 15px;
        display: flex;
        align-items: center;
        flex: 1 1 auto;
        height: 32px;
        user-select: none;

        .nav-icon {
          width: 36px;
        }

        &.collapse-bar {
          justify-content: flex-end;
          padding: 18px 15px;

          .icon {
            padding-right: 5px;
          }
        }
      }
    }
  }

  &.kpt-portal-navbar-collapsed {
    width: 52px;
    overflow: hidden;
    min-width: 52px;

    .nav-icon {
      min-width: 52px;
      padding-right: 52px;
    }

    ul li a {
      &.collapse-bar {
        .icon { padding-right: 10px; }
      }
    }
  }
}
</style>
